<style>
  svg > g[class*="raphael-group-"] > text{
    display: none !important;
  }

  #UserChart span,
  #UserChart svg{
    position: relative;
    width: 100% !important;
    height: auto !important;
    max-height: 400px;
  }

  #UserChart svg > g[class*="raphael-group-"] > text{
    display: none !important;
  }

  #UserChart svg > g:first-of-type > g:first-child{
    opacity: 0;
  }
</style>

<template>
  <div id="UserChart">
    <fusioncharts
      :type="type"
      :width="width"
      :height="height"
      :dataformat="dataFormat"
      :dataSource="dataSource"
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueFusionChartsComponent from 'vue-fusioncharts/component';

  import FusionCharts from 'fusioncharts';
  import Charts from 'fusioncharts/fusioncharts.charts';
  // import {yearlyChartData, monthlyChartData} from './data';

  const vueFusionCharts = VueFusionChartsComponent(FusionCharts, Charts);

  Vue.component('fusioncharts', vueFusionCharts);

  export default {
    name: 'usergraph',
    props: {
        caption: String,
        xAxisName: String,
        data: Object,
        timeFrame: String
    },
    mounted(){
      setTimeout(() => {
        const svg = this.$el.querySelector("svg");
        if(svg)
          svg.setAttribute("viewBox", `0 0 ${this.width} ${this.height}`);
      }, 200);
    },
    data() {
      return {
        type: "column2d",
        width: "700",
        height: "383",
        dataFormat: "json",
      }
    },
    watch: {
      timeFrame: function(newVal, oldVal) { // watch it
        setTimeout(() => {
          const svg = this.$el.querySelector("svg");
          if(svg)
            svg.setAttribute("viewBox", `0 0 ${this.width} ${this.height}`);
        }, 200);
      }
    },
    computed: {
      dataSource: function(){
        return {
            chart: {
                caption: this.caption,
                // subCaption: "In MMbbl = One Million barrels",
                xAxisName: this.timeFrame.charAt(0).toUpperCase() + this.timeFrame.substring(1),
                yAxisName: "No. of new users",
                // numberSuffix: "K",
                theme: "fusion",
                palettecolors: "29c3be",
                usePlotGradientColor: "0"
            },
            // data: {"year": yearlyChartData, "month": monthlyChartData}[this.timeFrame]
            data: this.data[this.timeFrame]
        }
      }
    }
  }
</script>
